import {useCallback,useEffect,useRef} from 'react';
import {client} from './api';
import {openingKind,timingBody} from './viewerPages';

/** Measures the time from asking for a page (click, page turn) to its first paint and reports it
 * once per page. `waiting` is true while the pages of the document are still being prepared. */
export function useViewTiming(documentId:string|undefined,pageId:string,waiting:boolean) {
  const key=documentId&&pageId?`${documentId}/${pageId}`:'';
  const timed=useRef({key:'',at:performance.now(),waited:false,reported:''});
  useEffect(()=>{if(waiting)timed.current.waited=true;},[waiting]);
  useEffect(()=>{
    // Another page (or a source still loading after one was shown) starts a new measurement;
    // the first page keeps the start of the viewer itself, so waiting for preparation is included.
    if(timed.current.key&&timed.current.key!==key)timed.current.at=performance.now();
    timed.current.key=key;
  },[key]);
  return useCallback(()=>{
    const state=timed.current;
    if(!documentId||!key||state.reported===key)return;
    state.reported=key;
    const body=timingBody(pageId,openingKind(key,state.waited),state.at,performance.now());
    state.waited=false;
    // Telemetry never interrupts reading the source.
    if(body)void client.POST('/api/v1/documents/{document_id}/view-timings',{params:{path:{document_id:documentId}},body}).catch(()=>undefined);
  },[documentId,pageId,key]);
}
